import { render, staticRenderFns } from "./fornitori.vue?vue&type=template&id=038d17d6"
import script from "./fornitori.vue?vue&type=script&lang=js"
export * from "./fornitori.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports